import {
  TREE,
} from '../constants'

import traverse from 'fc-utils/traverse'

type TokenSelector = any => ?string

export default (traverse([TREE, 'token']): TokenSelector)
